import { Provider } from '@angular/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
//import { KeycloakOptions, KeycloakService } from 'keycloak-angular';
import { AppInterceptor } from './shared/handlers/app-interceptor.handler';

import { AuthHttpInterceptor } from '@auth0/auth0-angular';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { CurrencyFormatPipe } from './shared/pipes/currency-format.pipe';

// function initializeKeycloak(keycloak: KeycloakService) {
//   return () => keycloak.init(APP_CONFIG.keycloak as KeycloakOptions);
// }

export const ServiceProviders: Provider[] = [
  {
    provide: HTTP_INTERCEPTORS,
    useClass: AuthHttpInterceptor,
    multi: true,
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: AppInterceptor,
    multi: true,
  },

  { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
  CurrencyFormatPipe,
];
